// Libraries
import React from 'react';
import ReactDOM from 'react-dom';

// App Component
import App from './App';

// Stylesheet
import './index.css';

// Render
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
